import React, {useEffect} from 'react';
import translate from '../../../utils/translations';
import './InsuranceFailedMessage.less';
import {SVGIcon} from '@homeaway/react-svg';
import {errorPresented, TRIP_DETAILS} from '../../../utils/edapUtils';
import {WarningIconMarkup, EdapInsuranceFailedEventkey} from './Constant';

const mapErrorMessages = (failedItems, translations) => {
    const errors = [];
    if (!failedItems || failedItems.length === 0) {
        return errors;
    }

    const translateField = (key) =>
        translate(translations, 'ui-development/shared', 'errorMessages', key);

    failedItems.forEach((item) => {
        const type = item.vasPaymentDetails.type;
        if (type && type.toLowerCase() === 'weather_promise') {
            return; // skip if type is 'weather_promise'
        }
        errors.push({
            title: translateField('insurtech.failed.error.title'),
            message: translateField('insurtech.failed.error.message'),
        });
    });

    return errors;
};

const InsuranceFailedMessages = ({confirmation, translations}) => {
    const failedInsurtechItems =
        confirmation?.priceDetails?.failedInsurtechItems;
    const genericErrors = mapErrorMessages(failedInsurtechItems, translations);

    useEffect(() => {
        if (genericErrors.length > 0) {
            errorPresented({
                actionLocation: TRIP_DETAILS,
                key: EdapInsuranceFailedEventkey,
            });
        }
    }, [genericErrors]);

    if (genericErrors.length === 0) {
        return null;
    }
    const warningIcon = WarningIconMarkup;

    return (
        <div
            className="insurance-failed-messages"
            role="status"
            data-stid="generic-insurance-failure"
            key={genericErrors[0].key}
        >
            <div className="insurance-failed-messages__icon-wrapper">
                <SVGIcon
                    className="insurance-failed-messages__warning-icon"
                    markup={warningIcon}
                    inline
                />
            </div>

            <div className="insurance-failed-messages__text">
                <div className="insurance-failed-messages__title">
                    {genericErrors[0].title}
                </div>
                <div className="insurance-failed-messages__message">
                    {genericErrors[0].message}
                </div>
            </div>
        </div>
    );
};

export default InsuranceFailedMessages;
